import { useEffect } from 'react';

export default function Preloader({ state }) {
    useEffect(() => {
        $('.preloader').fadeOut(1000);
    }, []);

    return (
        <div className="preloader">
            <div className="lds-ripple">
                <div className="preloader-container">
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal" />
                    <div className="petal-1" />
                    <div className="petal-1" />
                    <div className="petal-1" />
                    <div className="ball" />
                </div>
            </div>
        </div>
    );
}
